import styled from 'styled-components'
import { Grid, Container, Segment, Card, Image } from 'semantic-ui-react'

export const CustomCardGroup = styled(Card.Group)`
    &&&&{
        &>.ui.card {
            &>* {
                height: 100%;
            }
            @media (min-width: 768px) {
                width: calc(50% - 1.5em);
                margin-bottom: 0.5em;
                margin-top: 0.5em;
                &:nth-of-type(2n+1) {
                    margin-right: .5em;
                }
                &:nth-of-type(2n) {
                    margin-left: .5em;
                }
            }
        }
    }
`

export const MobileOnlyGrid = styled(Grid)`
    @media (min-width: 768px) {
        display: none!important;
    }
`
export const TabletOnlyGrid = styled(Grid)`
    @media (max-width: 767px) {
        display: none!important;
    }
`

export const BasedBodyContainer = styled.div`
    &&&>* {
        margin-top: 2em;
        margin-bottom: 2em;
    }
    & .ui.grid .row {
        padding-top: 0.3rem; //0.5 fepo olymp fepo_pro fieb tk tfieb
        padding-bottom: 0.3rem;
    }
    @media (min-width: 768px) {
        & .ui.grid {
            margin: 0;
        }
        &>.container>p {
            margin-left: 1em;
            margin-right: 1em;
        }
    }
    &&&>.container>.segment>.ui.grid {
        margin: -0.5em -1em;
    }
`

export const BasedFullWidthBackgroundContainer = styled.div`
    position: relative;
    padding: 1em 0;

    & .ui.stackable.cards {
        margin-top: 0;
        margin-bottom: 0;
    }

    @media (max-width: 767px) {
        padding-left: 0;
        padding-right: 0;

        & .ui.stackable.cards .card:first-child {
            margin-top: 0!important;
        }
        & .ui.stackable.cards .card:last-child {
            margin-bottom: 0!important;
        }
    }
    @media (min-width: 768px) {
        &>.container>p {
            margin-left: 1em;
            margin-right: 1em;
        }
    }
    /* @media (max-width: 1500px) {
        border-radius: 70% / 20%;
    } */
`

export const CustomImage = styled(Image)`
    width: ${({ $width }) => $width};
    height: ${({ $height }) => $height};
    @media (min-width: 768px) {
        margin: ${({ $margin }) => $margin};
    }
`
export const FlexBlock = styled.div`
    display: flex;
    margin: 0 0 .5em;
    &&&>img {
        margin-right: .8em;
        margin-top: -0.2em;
        margin-bottom: 0;
    }
    &.streamlined { //обтекание текста в мобильной версии
        @media (max-width: 767px) {
            display: block;
    
            &&&>img {
                float: left;
                width: auto;
            }
        }
    }
`
export const Link = styled.a`
    text-decoration: underline;
    cursor: pointer;
    color: inherit;
`

// export const CustomSegment = styled(Segment)`
//     @media (max-width: 767px) {
//         &.ui.segment {
//             padding: 0;
//         }
//     }
// `